
function getLastSeenKey(userId) {
  return `ultima_fecha_visto_${userId}`;
}

export function getLastSeen(userId) {
  if (!userId) return null;
  return localStorage.getItem(getLastSeenKey(userId));
}

export function updateLastSeenToNow(userId) {
  if (!userId) return;
  const nowIso = new Date().toISOString();
  localStorage.setItem(getLastSeenKey(userId), nowIso);
}